<template>
  <div class="rpt-content">
    <div class="search-box">
      <el-input v-model="tel" class="search-control-item" placeholder="请输入手机号" style="width: 200px;" />
      <el-select v-model="state" class="search-control-item" clearable style="width: 120px;" placeholder="申请状态">
        <el-option label="已提交" value="0"></el-option>
        <el-option label="审核中" value="1"></el-option>
        <el-option label="通过" value="2"></el-option>
        <el-option label="失败" value="3"></el-option>
      </el-select>
      <el-date-picker
        class="search-control-item"
        v-model="applyDate"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="申请开始日期"
        end-placeholder="申请结束日期"
        value-format="yyyyMMdd"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-date-picker
        class="search-control-item"
        v-model="createDate"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="注册开始日期"
        end-placeholder="注册结束日期"
        value-format="yyyyMMdd"
        :picker-options="pickerOptions"
      ></el-date-picker>

      <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search('btn')">查询</el-button>

      <download-excel class="export-excel-wrapper" :data="selectData" :fields="json_fields" name="企业申请列表.xls">
        <el-button type="success">导出</el-button>
      </download-excel>
    </div>

    <el-table
      @selection-change="handleSelectionChange"
      border
      v-loading="tableloading"
      :data="tableData"
      style="width: 100%"
      max-height="600"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
      <el-table-column prop="province_name" label="所在省"></el-table-column>
      <el-table-column prop="city_name" label="所在市"></el-table-column>
      <el-table-column prop="area_name" label="所在区"></el-table-column>
      <el-table-column prop="state" label="申请状态" align="center">
        <template slot-scope="scope">
          <span>{{ formatState(scope.row.state) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_apply" label="是否申请">
        <template slot-scope="scope">
          <span>{{ scope.row.is_apply == 1 ? '已申请' : '未申请' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="apply_time" label="申请时间">
        <template slot-scope="scope">
          <span>{{ formatDateTime(scope.row.apply_time, 'time') }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="create_time" label="注册时间">
        <template slot-scope="scope">
          <span>{{ formatDateTime(scope.row.create_time, 'time') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[50, 100, 200, 300]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'apply-detail',
  data() {
    return {
      tableloading: false,
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      tableData: [],

      selectData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/1/1`);
              picker.$emit('pick', [start, now]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const now = new Date();
              const end = new Date(now.setDate(0));
              const start = new Date(`${end.getFullYear()}/${end.getMonth() + 1}/1`);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/${now.getMonth() + 1}/1`);
              picker.$emit('pick', [start, now]);
            }
          }
        ]
      },

      // 导出字段
      json_fields: {
        企业名称: 'company_name',
        所在省: 'province_name',
        所在市: 'city_name',
        所在区: 'area_name',
        申请状态: 'state',
        是否申请: 'is_apply',
        申请时间: 'apply_time',
        注册时间: 'create_time'
      },

      // 查询字段
      applyDate: [],
      createDate: [],
      tel: '',
      state: ''
    };
  },
  computed: {
    begin_apply_datetime() {
      return this.applyDate[0] ? this.applyDate[0] + '000000' : '';
    },
    end_apply_datetime() {
      return this.applyDate[1] ? this.applyDate[1] + '235959' : '';
    },
    begin_create_datetime() {
      return this.createDate[0] ? this.createDate[0] + '000000' : '';
    },
    end_create_datetime() {
      return this.createDate[1] ? this.createDate[1] + '235959' : '';
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    // 表格选中数据变化
    handleSelectionChange(data) {
      this.selectData = data;
    },
    // 格式化申请状态
    formatState(val) {
      let states = ['已提交', '审核中', '通过', '失败'];
      if (val >= 0) {
        return states[val];
      } else {
        return '';
      }
    },
    search(type) {
      if (type == 'btn') this.pageIndex = 1;
      this.tableloading = true;
      request({
        url: '/api/rpt/apply/detail',
        data: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          tel: this.tel,
          state: this.state,
          begin_apply_datetime: this.begin_apply_datetime,
          end_apply_datetime: this.end_apply_datetime,
          begin_create_datetime: this.begin_create_datetime,
          end_create_datetime: this.end_create_datetime
        }
      }).then(res => {
        this.tableloading = false;
        if (res.success) {
          this.tableData = res?.result?.companyList;
          this.total = res?.result?.recordCount;
        }
      });
    }
  }
};
</script>

<style scoped>
.export-excel-wrapper {
  display: inline-block;
}
</style>
